import cx from 'classnames';
import { forwardRef } from 'react';

import { ConditionalView } from '../../utils/ConditionalView';
import { WrapTextNodes } from '../../utils/WrapTextNodes';
import styles from './Toggle.module.scss';
import usePresenter from './Toggle.presenter';
import type { ToggleProps } from './Toggle.types';

const Toggle = forwardRef<HTMLInputElement, ToggleProps>((props: ToggleProps, ref) => {
  const {
    disabled,
    invalid,
    isChecked,
    labelAlignment,
    onToggleChanged,
    otherInputProps,
    required,
    variantProps,
  } = usePresenter(props);

  return (
    <label
      className={cx(
        styles.toggle,
        props.className,
        {
          [styles.labelLeft]: labelAlignment === 'Left',
          [styles.labelRight]: labelAlignment === 'Right',
        },
      )}
      {...variantProps}
    >
      <input
        {...otherInputProps}
        type="checkbox"
        className={styles.input}
        checked={isChecked}
        onChange={onToggleChanged}
        disabled={disabled}
        required={required}
        ref={ref}
        id={props.id}
        aria-invalid={invalid}
      />
      <span className={cx(styles.track, { [styles.disabled]: disabled })}>
        <span className={styles.thumb} />
      </span>
      <ConditionalView condition={props.children}>
        <WrapTextNodes className={styles.text}>
          {props.children}
        </WrapTextNodes>
      </ConditionalView>
    </label>
  );
});

export default Toggle;